// Declare the global values used in this Component
declare var angular: angular.IAngularStatic;

import { Component } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';

import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'cts-bulk-upload-options-dialog',
    template: require('./cts-bulk-upload-options-dialog.component.html'),
})
export class CtsBulkUploadOptionsDialog {

    constructor(
        public dialogRef: MatDialogRef<CtsBulkUploadOptionsDialog>,
    ) {}

}

angular.module("comcast.directives").directive(
    'ctsBulkUploadOptionsDialog',
    downgradeComponent(
        // The inputs and outputs here must match the relevant names of the properties on the
        // "downgraded" component
        {component: CtsBulkUploadOptionsDialog, inputs: [], outputs: []}));
